export default "__VITE_ASSET__BUfQU40G__"